import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';

import LandingPage from '../LandingPage';
import GetStartedPage from '../../getStarted';
import { useHistory } from 'react-router-dom';
import AccessDeniedPage from '../AccessDeniedPage';
import { userSelector } from 'redux/selectors/userSelector';
import { useSelector } from 'react-redux';
import { isInitialSetupCompleted } from 'utils/userUtils';

export default function HomePage() {
	const { isAuthenticated, error, logout } = useAuth0();
	const history = useHistory();
	const userData = useSelector(userSelector);
	if (isAuthenticated && isInitialSetupCompleted(userData)) {
		history.push('/projects');
		return null;
	} else if (error) {
		logout();
		return null;
	} else {
		return <GetStartedPage />;
	}
}
